export default "__VITE_ASSET__BGX5hoSD__"